<template>
  <nav :aira-label="arialabel">
    <ul
      class="h-8 md:h-12 flex justify-between items-end sm:justify-start sm:text-base text-primary text-sm"
    >
      <li v-for="item in menuitems" :key="item.slug" class="sm:mr-8 last:mr-0">
        <RouterLink
          :to="item.slug"
          class="flex-a h-8 md:h-10 py-1 border-b-5 focus-b"
          :class="[
            `hover:border-${item.palette.primary}`,
            `focus:border-${item.palette.primary}`,
            active(item)
              ? `border-${item.palette.primary}`
              : 'border-transparent'
          ]"
          @click.native="handleFocus"
        >
          {{ htmlDecode(item.title) }}
        </RouterLink>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Menu',

  props: {
    arialabel: {
      type: String,
      default: ''
    },
    menuitems: {
      type: Array,
      default: () => []
    },
    category: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapState(['touch', 'mobile']),
    ...mapGetters([])

    // buttonWidth() {
    //   const count = 100 / this.menuitems.length
    //   return count
    // }
  },

  methods: {
    handleFocus() {
      // this.$refs.MenuFocusTarget.querySelector('h1').focus()
      // console.log('focus')
    },
    active(item) {
      if (this.category.type === 'subject' && item.slug === 'subjects')
        return true
      return item.slug === this.category.slug
    }
  }
}
</script>
